import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ColorRow from './ColorRow/ColorRow';
import classes from './ProfilePhotoColorSelector.module.css';
import Spinner from 'components/UI/Spinner/Spinner';
import { getRgbFromColorName } from 'shared/utility';

const profilePhotoColorSelector = (props) => {
  const containerClasses = [classes.ProfilePhotoUploader];
  if (props.showColorSelector) containerClasses.push(classes.ShowColorSelector);
  if (props.isValid === false) containerClasses.push(classes.Invalid);
  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.LeftElement}>
        <div className={[classes.ColorSelector, classes.Left].join(' ')}>
          <div className={classes.Row}>
            <ColorRow selectedColor={props.color} handleColorSelection={props.handleColorSelection} startIndex={0} length={3} />
          </div>
          <div className={classes.Row}>
            <ColorRow selectedColor={props.color} handleColorSelection={props.handleColorSelection} startIndex={6} length={3} />
          </div>
          <div className={classes.Row}>
            <ColorRow selectedColor={props.color} handleColorSelection={props.handleColorSelection} startIndex={12} length={3} />
          </div>
        </div>
        <div className={classes.FileUploadContainer}>
          <label
            htmlFor="file-upload"
            className={props.profileCreated === true ? [classes.CustomFileUpload, classes.Update].join(' ') : classes.CustomFileUpload}
          >
            {props.profileCreated === true ? 'Update' : 'Add'} Photo
          </label>
          <input className={classes.Image} onChange={props.handleImageUpload} id="file-upload" type="file" />
        </div>
      </div>

      <div className={classes.ProfileImage}>
        {props.loadingImage ? (
          <div className={classes.ProfileImageContainer} style={{ backgroundColor: props.color ? getRgbFromColorName(props.color) : undefined }}>
            <Spinner className={classes.Spinner} small />
          </div>
        ) : (
          <div>
            <label
              htmlFor="file-upload"
              className={props.profileCreated === true ? [classes.ProfileImage, classes.Update].join(' ') : classes.ProfileImage}
            >
              <div className={classes.ProfileImageContainer} style={{ backgroundColor: props.color ? getRgbFromColorName(props.color) : undefined }}>
                {props.profileThumbUrl && props.profileThumbUrl.charAt(props.profileThumbUrl.length - 1) !== '/' ? (
                  <img src={props.profileThumbUrl} className={classes.ProfileThumbImage} />
                ) : (
                  <FontAwesomeIcon icon="user" className={classes.UserIcon} />
                )}
              </div>
            </label>
            <input className={classes.Image} onChange={props.handleImageUpload} id="file-upload2" type="file" />
          </div>
        )}
      </div>
      <div className={classes.RightElement}>
        <div className={[classes.ColorSelector, classes.Right].join(' ')}>
          <div className={classes.Row}>
            <ColorRow selectedColor={props.color} handleColorSelection={props.handleColorSelection} startIndex={3} length={3} />
          </div>
          <div className={classes.Row}>
            <ColorRow selectedColor={props.color} handleColorSelection={props.handleColorSelection} startIndex={9} length={3} />
          </div>
          <div className={classes.Row}>
            <ColorRow selectedColor={props.color} handleColorSelection={props.handleColorSelection} startIndex={15} length={3} />
          </div>
        </div>
        <div onClick={props.handleColorSelectorToggle} className={classes.SelectColor}>
          Select Color*
        </div>
      </div>
    </div>
  );
};

export default profilePhotoColorSelector;
